import { useEffect, useState, useCallback } from "react";
import "./App.less";
import Login from "./pages/login";
import Home from "./pages/home";
import { SkeletonParagraph, SkeletonNormalList } from '@hose/eui'
import { ConfigTheme } from '@hose/eui-theme'
import { usePostmate, cleanupPostmate } from './hooks/useChatInitialization';
import Logger from './utils/Logger'
import {getParamFromUrl} from './utils/tools'
import { sendRefreshToken } from './utils/postmate'

function SkeletonLoading() {
	return <div className="skeleton-loading">
		<div className="skeleton-loading-right">
			<SkeletonParagraph animated />
		</div>
		<div className="skeleton-loading-left">
			<SkeletonNormalList animated showTitle showText showAvatar showAction />
		</div>
	</div>
}

// 主应用组件
function AppContent({ logger }: { logger?: Logger }) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
	

	const initHoseThemeEUI = useCallback((color: string) => {
		const euiTheme = new ConfigTheme()
		euiTheme.config({ prefix: 'eui', platform: 'eui', brandColor: color })
	}, [])

	useEffect(() => {
		initHoseThemeEUI('#2555ff')
		const login = async () => {
			try {
				await Login.finishLogin();
			} catch (e: any) {
				// 需要重新更新 token
				sendRefreshToken();
				setError(e?.message || e);
			} finally {
				setLoading(false);
			}
		};
		login();
	}, [initHoseThemeEUI]);

	if (loading) {
		return <SkeletonLoading />;
	}
	if (error) {
		return <div className="chat-error">Error: {error}</div>;
	}

	return (
		<Home
			fetcher={Login.fetcher}
			logger={logger}
		/>
	);
}

function App() {
	const { isEmbedded, isReady } = usePostmate();
	const [logger, setLogger] = useState<Logger>()

	// 添加清理逻辑
	useEffect(() => {
		return () => {
			if (isEmbedded) {
				cleanupPostmate();
			}
		};
	}, [isEmbedded]);

	useEffect(() => {
		if (!window.HSM) return
		const _logger = new Logger()
		_logger.logInstance = window.HSM.datafluxLogs
		setLogger(_logger)
	}, [])

	return (
		<div className={`App ${isEmbedded ? 'App--embedded' : 'App--standalone'} ${getParamFromUrl('platform') === 'mobile' ? 'App--mobile' : ''}`}>
			{
				(isEmbedded && !isReady) ? <SkeletonLoading/> : <AppContent logger={logger}/>
			}
		</div>
	);
}

export default App;
